<template>
    <div>
    <!-- <v-app id="inspire"> -->
    <v-sheet
      class="mx-auto"
      :max-width="widthNum"
      :dark="true"
    >
      <v-slide-group
        multiple
        :show-arrows="true"
        dark
        :next-icon="'〉'"
        :prev-icon="'〈'"
      >

      <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/USA.png"  @click="selectState('US')" />
        </v-slide-item>

 <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/AL.png" @click="selectState('01')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/AK.png" @click="selectState('02')" />
        </v-slide-item>
        
        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/AZ.png"  @click="selectState('04')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/AR.png"  @click="selectState('05')" />
        </v-slide-item>

      
        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/CA.png" @click="selectState('06')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/CO.png" @click="selectState('08')" />
        </v-slide-item>

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/CT.png" @click="selectState('09')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/DC2.png" @click="selectState('11')" />
        </v-slide-item>

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/DE.png" @click="selectState('10')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/FL.png" @click="selectState('12')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/GA.png" @click="selectState('13')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/HI.png" @click="selectState('15')" />
        </v-slide-item>

        

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/ID.png" @click="selectState('16')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/IL.png" @click="selectState('17')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/IN.png" @click="selectState('18')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/IA.png" @click="selectState('19')" />
        </v-slide-item>

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/KS.png" @click="selectState('20')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/KY.png" @click="selectState('21')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/LA.png" @click="selectState('22')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/ME.png" @click="selectState('23')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MD.png" @click="selectState('24')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MA.png" @click="selectState('25')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MI.png" @click="selectState('26')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MN.png" @click="selectState('27')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MS.png" @click="selectState('28')" />
        </v-slide-item>

        
      <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/MO.png" @click="selectState('29')" />
        </v-slide-item>
        

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/MT.png" @click="selectState('30')" />
        </v-slide-item>

        

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/NE.png" @click="selectState('31')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/NV.png" @click="selectState('32') "/>
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/NH.png" @click="selectState('33')" />
        </v-slide-item>

        

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/NJ.png" @click="selectState('34')" />
        </v-slide-item>

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/NM.png" @click="selectState('35')" />
        </v-slide-item>

        

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/NY.png" @click="selectState('36')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/NC.png" @click="selectState('37')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/ND.png" @click="selectState('38')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/OH.png" @click="selectState('39')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/OK.png" @click="selectState('40')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/OR.png" @click="selectState('41')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/PA.png" @click="selectState('42')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/RI.png" @click="selectState('44')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/SC.png" @click="selectState('45')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/SD.png" @click="selectState('46')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/TN.png" @click="selectState('47')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/TX.png" @click="selectState('48')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/UT.png" @click="selectState('49')" />
        </v-slide-item>

        

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/VT.png" @click="selectState('50')" />
        </v-slide-item>

        <v-slide-item 
        >
         <img class="selectorIcon" src="../assets/state-icons/VA.png" @click="selectState('51')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/WA.png" @click="selectState('53')" />
        </v-slide-item>

        

        <v-slide-item
        >
        <img class="selectorIcon" src="../assets/state-icons/WV.png" @click="selectState('54')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/WI.png" @click="selectState('55')" />
        </v-slide-item>

        <v-slide-item
        >
         <img class="selectorIcon" src="../assets/state-icons/WY.png" @click="selectState('56')"/>
        </v-slide-item> 

      </v-slide-group>
    </v-sheet>
  <!-- </v-app> -->
 
</div>
</template>
<script>
export default {
  props: {
    widthNum: {
      type: Number
    }
  },
  methods: {
        selectState(value) {
          this.$store.dispatch('selectState', value);
        },
  }
}
</script>